import { observer } from 'mobx-react-lite';
import { ChartTooltip } from 'src/features/drilling-chart/features/chart-tooltip/chart-tooltip';
import { useIsOutOfViewport } from 'src/shared/hooks/use-is-out-of-viewport';

import { LoadingRigOperations, WellRigOperationStage } from '../../../presets/drilling-wells-chart/entities';
import { WellsViewSettingsProvider } from '../../../presets/drilling-wells-chart/wells-view-settings-provider';
import { Viewport } from '../../../shared/viewport/viewport';
import { DrillingStageTooltipInner } from '../../data-items-empty/view/drilling-stage-tooltip-inner';
import { DrillingStageWrapper } from '../../drilling-step-wrapper';
import { EmptyBlockWrapper } from '../../empty-block-wrapper';

import styles from './data-items-full.module.scss';

interface Props {
  item: WellRigOperationStage | LoadingRigOperations;
  horizontalViewport: Viewport;
  verticalViewport: Viewport;
  viewProvider: WellsViewSettingsProvider;
  onClick(wellId: string | number): void;
}

export const WellsDataItemFull = observer(function WellsDataItemFull({
  item,
  horizontalViewport,
  verticalViewport,
  viewProvider,
  onClick,
}: Props) {
  const isOutOfViewport = useIsOutOfViewport(item, horizontalViewport);

  if (item instanceof LoadingRigOperations) {
    return (
      <EmptyBlockWrapper
        item={item}
        horizontalViewport={horizontalViewport}
        verticalViewport={verticalViewport}
        className={styles.loadingBlock}
      />
    );
  }

  if (item instanceof WellRigOperationStage) {
    if (item.parentWell) {
      const tooltipPlacement = isOutOfViewport ? 'rightTop' : 'top';

      return (
        <ChartTooltip
          content={<DrillingStageTooltipInner stage={item} viewProvider={viewProvider} />}
          placement={tooltipPlacement}
        >
          <DrillingStageWrapper
            item={item}
            horizontalViewport={horizontalViewport}
            verticalViewport={verticalViewport}
            viewProvider={viewProvider}
            onClick={onClick}
          />
        </ChartTooltip>
      );
    }

    return (
      <DrillingStageWrapper
        item={item}
        horizontalViewport={horizontalViewport}
        verticalViewport={verticalViewport}
        viewProvider={viewProvider}
        onClick={onClick}
      />
    );
  }

  return null;
});
